import { useQuery } from "@tanstack/react-query";
import { getSupplierRevisions } from "../api/final-scoring-api";

export const useSupplierRevisions = (
	rfxId: number,
	evalId: number,
	inviteId: number
) =>
	useQuery({
		queryKey: ["supplier-revisions", rfxId, evalId, inviteId],
		queryFn: () => getSupplierRevisions(rfxId, evalId, inviteId),
		staleTime: 5 * 60 * 1000,
		enabled: !!rfxId && !!evalId && !!inviteId,
	});
